/**
 * The self-serve plan catalogue the portal shows: which plans exist per platform, in
 * ladder order, and the one-line description under each plan name. Single source for
 * AddSubscriptionModal and UpgradePlanModal (both used to carry their own copy).
 *
 * Device limits mirror portal-api plan_prices.max_devices: P15/P25/P50/P75/P150 =
 * 100/200/500/1,000/2,000 (UniFi), U25/U50/U100/U200 = 100/250/750/1,500 (UISP,
 * plans/2026-10-12-uisp-productisation-design.md §5). UCustom is quote-only and never listed.
 */
export type SignupPlatform = 'UniFi' | 'UISP';

export const UNIFI_PLAN_ORDER = ['P15', 'P25', 'P50', 'P75', 'P150'] as const;
export const UISP_PLAN_ORDER = ['U25', 'U50', 'U100', 'U200'] as const;

export type UnifiPlan = (typeof UNIFI_PLAN_ORDER)[number];
export type UispPlan = (typeof UISP_PLAN_ORDER)[number];
export type PlanName = UnifiPlan | UispPlan;

export const PLAN_ORDER_BY_PLATFORM: Record<SignupPlatform, readonly PlanName[]> = {
  UniFi: UNIFI_PLAN_ORDER,
  UISP: UISP_PLAN_ORDER,
};

export const PLAN_DESCRIPTIONS: Record<PlanName, string> = {
  P15: 'Up to 100 devices',
  P25: 'Up to 200 devices',
  P50: 'Up to 500 devices',
  P75: 'Up to 1,000 devices',
  P150: 'Up to 2,000 devices',
  U25: 'Up to 100 devices',
  U50: 'Up to 250 devices',
  U100: 'Up to 750 devices',
  U200: 'Up to 1,500 devices',
};

/** The one place an API plan-name string is looked up; undefined for plans not self-serve (e.g. UCustom). */
export function describePlan(name: string): string | undefined {
  return (PLAN_DESCRIPTIONS as Record<string, string | undefined>)[name];
}
